module.exports = __webpack_public_path__ + "img/login_1.e70ac6c4.jpg";